module.exports = __webpack_public_path__ + "e2663bdca25c257ef90e5e151db1067c.pdf";